import { Component, Injector, OnInit } from '@angular/core';
import { GeralListaModule } from './gerallista.module';
import { ListaSimplesGenerica } from '../../generic/listagenerica/listasimplesgenerica';
import { SuporteTecnico } from 'src/app/model/geral/suporteTecnico';
import { SuporteTecnicoService } from 'src/app/services/geral/suporte-tecnico.service';

@Component({
  selector: 'app-lista-suporte-tecnico',
  templateUrl: '../../generic/listagenerica/listasimples.component.html',
  styleUrls: [ '../../generic/listagenerica/listasimples.component.css']
})

export class ListaSuporteTecnicoComponent extends ListaSimplesGenerica<SuporteTecnico> implements OnInit {

  override obj = new SuporteTecnico();

  constructor(
    injectorObj: Injector,
    api: SuporteTecnicoService) 
  {
    super(injectorObj, api);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraList(res: any) {
}

  override getColorCell(valor: any) {   
  }

}
